
import React from "react";

const UserProjectsHeader: React.FC = () => {
  return (
    <div className="w-full text-center py-10 bg-[#0e7cb4] text-white">
      <h1 className="text-3xl font-bold mb-2">PROJETOS DE IMPACTO SOCIOCLIMÁTICO</h1>
    </div>
  );
};

export default UserProjectsHeader;
